module.exports = __webpack_public_path__ + "images/bank-65a682.svg";